/* eslint-disable react/no-unescaped-entities */

import React from 'react';
import Head from 'next/head';

export const LegalContent = () => {
  return (
    <>
      <Head>
        <meta name="robots" content="noindex" />
      </Head>

      <div id="legal">
        <h4>NOTICE: Please read this legal disclaimer</h4>
        <p>
          INFORMATION ON THIS WEB SITE IS PROVIDED {String.fromCharCode(34)}AS
          IS{String.fromCharCode(34)} WITHOUT EITHER EXPRESS OR IMPLIED WARRANTY
          and although it is believed accurate at time of posting, there may be
          some inaccurate, and/or out-of-date material. Clayton may make
          improvement and/or changes in products and services at anytime without
          notice.
        </p>
        <p>
          Clayton makes no representations as to material found on Web sites
          published by others which may be accessed through this site. Such
          information could be inaccurate, contain viruses, and present other
          problems for the user. Clayton will not be responsible even if notice
          of such had been received.
        </p>
        <h4>Privacy Policy</h4>
        <p>
          We respect the privacy of every customer. We strive to protect
          personal information and maintain customer trust. Please see our{' '}
          <a href={`/privacy`} target="_blank" rel="noreferrer">
            privacy policy
          </a>
          .
        </p>
        <h3 className="website-info">
          Web Site Information Collection and Use Practices and Web Site Use
          Terms and Conditions
        </h3>
        <p>(effective January, 2021)</p>
        <p>
          We have prepared this policy to help you understand more about how we
          collect, use, and disclose information from web site visitors.
          References to {String.fromCharCode(34)}web sites
          {String.fromCharCode(34)}
          includes mobile applications that we may publish. This policy does not
          cover information that we collect about you outside of our normal web
          site services. This policy also does not cover information that you
          voluntarily make public.
        </p>
        <h4>What information do you collect about me?</h4>
        <p>
          The information that we collect about you generally falls into two
          categories, information that you provide and information that is
          automatically collected.
        </p>
        <div className="indent">
          <h4 className="standard underlined-header">
            Information that you provide.
          </h4>
          <p>
            You may provide information to us through our web sites that you
            visit. This information may consist of, but is not limited to,
            personal contact information (name, address, phone number, email
            address, user ID and password), requests for services, banking and
            financial information, information submitted with a credit
            application, bid information, quote requests and claim submission.
            We do not collect personally identifiable information unless you
            choose to provide such information voluntarily.
          </p>
          <h4 className="standard underlined-header">
            Social media information
          </h4>
          <p>
            Our site may provide you the convenience of creating an account
            through a social media service. If you create an account, access or
            log-in to our site through a social media service, the information
            we collect about you may include name, email, phone, profile
            picture, social media service, zip code, and any other information
            you have given us or permitted the social media service to share
            with us. By creating an account, accessing or logging into our site
            via a social media service you are authorizing us to collect, store
            and use such gathered information and content in accordance with our
            web site information collection and use practices.
          </p>
          <h4 className="standard underlined-header">
            Automatically collected information
          </h4>
          <p>
            When you visit our web sites we, and third party vendors that we may
            use, may automatically collect information from you that consists
            of, but is not limited to, IP address, geolocation, device type,
            connection information such as browser type and version, plug-in
            types and versions, operating system, demographic information, which
            of our web sites you visit and which web sites not affiliated with
            us that you visit in addition to other analytic tracking
            information. We may also automatically collect information about
            your visits to and use of our web sites regarding length, timing,
            frequency, products viewed or pages and screens visited.
          </p>
          <p>
            Our web sites are not designed for use by children under the age of
            13. Therefore, we do not knowingly attempt to solicit or receive any
            information from children.
          </p>
        </div>
        <h4>How do you use this information?</h4>
        <p>
          Information that you provide is used for a variety of purposes
          including but not limited to contacting you, either by us or by an
          affiliated or nonaffiliated third party, regarding services or
          information you have requested or to process payments or claims you
          have submitted. We may also use or share your contact information,
          which information may be enhanced or merged with data collected from
          other sources to the extent permitted by law, to tell you about
          information you might find useful or interesting regarding our
          products and services as well as the products and services of our
          affiliates or nonaffiliated third parties.
        </p>
        <p>
          Information that is automatically collected is used to optimize web
          site performance, retrieve user preferences, and ensure data integrity
          as well as to provide third parties with usage statistics in an
          aggregated form not identifying individual users. Automatically
          collected information is also used by third party vendors to help us
          with online tracking and to provide you with targeted display
          advertisements, also known as behavioral advertising, on other web
          sites that you visit. We and third party vendors, including Google,
          use cookies to provide you with these advertisements. The cookies that
          we and third party vendors such as Google use to provide you with ads
          based on your past visits to our web sites include both first party
          cookies (such as the Google Analytics cookie) and third party cookies
          (such as the DoubleClick cookie) used together to report how the ad
          impressions and advertisements that you are provided and interact with
          are related to visits to our web sites. We do not track URLs that you
          type into your computer browser, but we do use cookies to track which
          web sites you visit on the Internet after you leave our web site.
        </p>
        <h4>With whom do you share this information?</h4>
        <p>
          Information that you provide and that is automatically collected is
          shared with our affiliates and partners, and also non-affiliated third
          parties, for the purposes described in this policy.
        </p>
        <p>
          We may also share information with law enforcement agencies,
          governmental officials or other parties as required by law and when we
          believe that disclosure is necessary to protect our rights or property
          and/or comply with a judicial proceeding, court order, or legal
          process served.
        </p>
        <p>
          We give you the opportunity to control the use of your personally
          identifiable information for purposes other than to fulfill services
          you have requested and process payments or claims you have submitted.
          For information about those choices, please{' '}
          <a
            href={`/privacy`}
            target="_blank"
            className="click"
            rel="noreferrer"
          >
            click here
          </a>{' '}
          for our privacy policy.
        </p>
        <h4>How do you protect the security of the information you store?</h4>
        <p>
          We store information on our servers to carry out the purposes
          described here. While we use reasonable security measures, we cannot
          guarantee that the Internet or your mobile device will be completely
          secure. Our intent is to maintain any data provided as confidential,
          however, information transmitted over the Internet cannot be
          guaranteed to remain confidential and we assume no responsibility for
          maintaining such information as confidential. We encourage you to take
          steps to protect yourself online, including ensuring that any online
          account information you have remains secure. For example, do not share
          your passwords with other people.
        </p>
        <p>See the limitation of Liability and Disclaimer below.</p>
        <h4>What are cookies?</h4>
        <p>
          When you visit our web sites, we and third party vendors that we may
          use may send one or more cookies or online tracking mechanisms to your
          computer or other device that uniquely identifies your browser. A
          cookie is a small file containing a string of characters that are
          stored as text files by your browser on your computer
          {String.fromCharCode(39)}s hard drive. We use cookies to track web
          analytics information and session information including user trends
          and search preferences. The purposes for tracking include but are not
          limited to improving the quality of our services, storing and
          retrieving user preferences and providing you with advertisements that
          may be of interest to you as described above in{' '}
          <em>
            <u className="standard emphasize">
              Automatically collected information
            </u>
          </em>
          . Cookies collect anonymous information, both individually and in the
          aggregate, but do not collect personally identifiable information.
        </p>
        <h4>
          What choices do I have regarding your use of information about me?
        </h4>
        <p>
          You can set your browser to notify you before you receive cookies so
          you have a chance to accept the cookies, and you can set your browser
          to turn off cookies by updating your privacy settings in your browser.
          Please note that if you choose to reject or disable cookies, your
          access to certain areas of our web sites may be limited. You may opt
          out of the use of cookies used for remarketing purposes and behavioral
          advertising by visiting the Network Advertising Initiative opt out
          page at{' '}
          <a
            href="https://optout.networkadvertising.org"
            target="_blank"
            rel="noreferrer"
          >
            https://optout.networkadvertising.org
          </a>
          . If you prefer not to have your IP address and corresponding
          geographic information collected for web site analytic purposes, you
          may download and install the Google Analytic Opt-out Browser Add-on
          which is available at{' '}
          <a
            href="https://tools.google.com/dlpage/gaoptout/"
            target="_blank"
            rel="noreferrer"
          >
            https://tools.google.com/dlpage/gaoptout/
          </a>
          . You may also change your ad settings at{' '}
          <a
            href="https://www.google.com/settings/ads"
            target="_blank"
            rel="noreferrer"
          >
            http://www.google.com/settings/ads
          </a>
          &nbsp; to control certain interest based ads.
        </p>
        <p>
          If you provide your email address to opt in to receiving future
          commercial marketing emails from us and our affiliates, then we may
          send information to you about our products or services and the
          products and services of our affiliates. To opt out from receiving
          commercial marketing email communications from us, please click on the
          opt-out (unsubscribe) link in the message you receive from us.
        </p>
        <h4>Third party web site links</h4>
        <p>
          As a convenience to you, this web site may provide links to third
          party web sites on the Internet which may be maintained by
          unaffiliated third parties. Unless we expressly state otherwise, we do
          not control, sponsor, endorse or approve any content, information,
          services or products that may be available on the web site links that
          we provide. We are not responsible for the accuracy of any information
          received through a linked third party web site, any services or
          products that may be obtained through third party web site links or
          viruses that may reside on linked third party web sites.
        </p>
        <p>
          Your use of this web site is your acknowledgement and agreement that
          we are not responsible or liable to you or any other person for any
          claim which may result from your use of any third party web site
          content, services or products.
        </p>
        <p>
          Unaffiliated third party web sites are not within our control. When
          you link to those web sites you leave our web site and your
          communications are no longer subject to our web site data collection
          policies. Your interaction and browsing on any other web site that we
          may link to is subject to that web site{String.fromCharCode(39)}s own
          privacy security and policies. We recommend you review those rules and
          policies before proceeding on any third party web sites.
        </p>

        <h4>Communications Terms and Conditions</h4>
        <p>
          By submitting a webform through ClaytonHomes.com, you agree that
          Clayton Homes, our affiliates, or our service providers can contact
          you for informational purposes, at any number you provide us, using an
          automatic telephone dialing system or prerecorded or artificial voice
          calls or texts. We may contact you to provide you with information
          regarding Clayton Homes products. You may opt-out of receiving these
          informational calls or texts by: (a) calling us at 865-380-3000; or
          (b) texting STOP to 865-324-5209 or in response to any informational
          text (after texting STOP, you will receive one confirmation text from
          us).
        </p>
        <p>
          If you have agreed to receive telemarketing texts from us, our
          affiliates, and our service providers, you may opt-out of receiving
          telemarketing texts at any time by (a) calling us at 865-380-3000; or
          (b) texting STOP to 865-324-5209 or in response to any telemarketing
          text (after texting STOP, you will receive one confirmation text from
          us). If you opt-out of receiving telemarketing texts, you can still
          use and access our services. Agreeing to receive telemarketing texts
          is not a condition of purchase.
        </p>
        <p>
          You agree to notify us immediately at 865-380-3000 if you change
          telephone numbers or are no longer the subscriber or usual user of a
          telephone number that you gave to us. You agree that we may monitor,
          record, retain and reproduce your text messages, telephone calls, and
          other communications with us. Data and message rates may apply. See
          your carrier for more information.
        </p>
        <p>
          You also agree that we may contact you at any email address you
          provide to us, including for marketing purposes. To opt-out from
          receiving marketing email communications from us, please click on the
          opt-out (unsubscribe) link in the message you receive from us.
        </p>

        <h4>Your Nevada Privacy Rights</h4>
        <p>
          If you are a Nevada resident, under Nevada Revised Statutes §§
          603A.300 et seq., you have the right to submit a Verified Request
          directing us not to sell certain information we may collect from you
          and that you provide through our websites. It is currently our
          practice not to sell such information, but if you would like to submit
          a Verified Request, please write us at: Online Privacy Department,
          5000 Clayton Rd., Maryville, TN 37804.
        </p>
        <p>
          For all requests, please include your name, street address, city,
          state and zip code. We will not accept requests via the telephone,
          email or by facsimile. We are not responsible for notices that are not
          labeled properly, or do not have complete information.
        </p>

        <h4>Your California Privacy Rights</h4>
        <p>
          If you are a California resident, under California Civil Code{' '}
          {String.fromCharCode(167)}1798.83 you have the right to request
          certain information regarding our disclosure of personal information
          to third parties for their direct marketing purposes. To make such a
          request, please write us at: CMH Services, Attention: Online Privacy
          Department, 5000 Clayton Rd., Maryville, TN 37804.
        </p>
        <p>
          For all requests, please include your name, street address, city,
          state and zip code. We will not accepts requests via the telephone,
          email or by facsimile. We are not responsible for notices that are not
          labeled properly, or do not have complete information.
        </p>
        <h4>Copyright Infringement</h4>
        <p>
          We respect and are committed to protecting copyright and intellectual
          property rights of others and we expect users of our web sites to do
          the same. The Digital Millennium Copyright Act of 1998 (
          {String.fromCharCode(34)}DMCA{String.fromCharCode(34)}), Title 178
          U.S.C.
          {String.fromCharCode(167)}512, provides recourse for copyright owners
          who believe that material displayed or used on our web sites infringes
          rights under copyright law. If you believe that any materials used or
          displayed on our web sites infringes your copyright, you may send us a
          notice requesting that the material be removed. To file a copyright
          infringement notice with us, you will need to send a written
          communication that includes substantially the following information:
        </p>
        <ul className="copyright-infringement">
          <li>
            A physical or electronic signature of a person authorized to act on
            behalf of the owner of an exclusive right that is allegedly
            infringed.
          </li>
          <li>
            Identification of the copyrighted work claimed to have been
            infringed, or if multiple copyrighted works at a single online site
            are covered by a single notification, a representative list of such
            works at that site. Please describe the work and where possible
            include a copy of the URL location of an authorized version of the
            work.
          </li>
          <li>
            Identification of the material that is claimed to be infringing or
            to be the subject of infringing activity and that is to be removed
            or access to which is to be disabled, and information reasonably
            sufficient to permit us to locate the material on our web sites
            (providing URLs in your notice where the content is located will
            help us locate the content).
          </li>
          <li>
            Your contact information, name, address, telephone number, or
            electronic mail address at which you can be contacted.
          </li>
          <li>
            A statement that you, as the complaining party, have a good faith
            belief that use of the material in the manner complained of is not
            authorized by you, the copyright owner, your agent or the law.
          </li>
          <li>
            A statement that the information in the notice is accurate, and
            under penalty of perjury, that you are authorized to act on behalf
            of the owner of an exclusive right that is allegedly infringed.
          </li>
        </ul>
        <p>Provide this information to our designated DMCA Agent at:</p>
        <p className="indent">
          Online Privacy Department
          <br />
          5000 Clayton Rd.
          <br />
          Maryville, TN 37804
        </p>
        <h4>Ownership of Web Site Contents</h4>
        <p>
          Unless otherwise stated herein, we and our licensors are the sole
          owners of this web site and all of its contents, including without
          limitation, the images and all information, services, features,
          functions, copyrights, trademarks, service marks, and other
          intellectual property rights contained within this web site. You agree
          that all right, title and interest in this web site will remain ours
          or our licensors{String.fromCharCode(39)} exclusive property. Nothing
          in these Terms and Conditions for Web Site Use gives you a right to
          reproduce, copy, distribute, sell, broadcast, license, or otherwise
          use the images on the web site, our name or any of our trademarks,
          logos, domain names, or other distinctive brand features. You may not
          modify, rent, lease, sell, distribute, or create derivative works
          based on the web site unless we have given you prior written consent
          to do so. You may only use the web site for personal, non-commercial
          purposes.
        </p>
        <h4>Use of Our Web Site Content</h4>
        <p>
          You may link to our content but only for your personal use and
          provided the link or post does not imply any sponsorship or
          endorsement by us or make use of a logo or trademark without written
          consent of the logo or trademark owner. You may not frame, or in-line
          link to any of the content on our sites or incorporate into any other
          web site any content from our web sites.
        </p>
        <h4>Limitation of Liability and Disclaimer</h4>
        <p>
          THE CONTENT ON OR AVAILABLE THROUGH THIS WEB SITE IS PROVIDED{' '}
          {String.fromCharCode(34)}AS IS{String.fromCharCode(34)} AND WITHOUT
          WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, AS PERMISSIBLE
          UNDER APPLICABLE LAW. WE DISCLAIM ALL EXPRESS OR IMPLIED WARRANTIES,
          INCLUDING BUT NOT LIMITED TO, IMPLIED WARRANTIES OF MERCHANTABILITY,
          FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. WE MAKE NO
          REPRESENTATION OR WARRANTY THAT THE OPERATION OF THE WEB SITE WILL
          MEET YOUR OR ANY OTHER USER'S REQUIREMENTS, THAT ACCESS WILL BE
          UNINTERRUPTED, SECURE OR FREE OF ERRORS, VIRUSES OR OTHER HARMFUL
          ELEMENTS, THAT THE WEB SITE IS FREE FROM DEFECTS OR THAT THE WEB SITE
          MATERIALS ARE CORRECT, ACCURATE OR RELIABLE. WE DISCLAIM ALL
          WARRANTIES, EXPRESS OR IMPLIED, IN CONNECTION WITH THIS WEBSITE AND
          YOUR USE OF THIS WEBSITE AND ASSUME NO LIABILITY OR RESPONSIBILITY FOR
          UNAUTHORIZED ACCESS TO OR USE OF OUR SECURE SERVERS AND/OR ANY AND ALL
          PERSONAL INFORMATION AND/OR FINANCIAL INFOMRATION STORED ON THOSE
          SERVERS.
        </p>
        <p>
          YOU AGREE THAT YOU WILL BE RESPONSIBLE FOR THE ENTIRE COST OF REPAIR
          OR SERVICE THAT MAY BE NECESSARY FOR YOUR DATA, SOFTWARE PROGRAMS OR
          COMPUTER EQUIPMENT CAUSE BY ANY VIRUSES, MALWARE, ERRORS OR OTHER
          PROBLEMS FROM YOUR USE OR VISITING THIS WEB SITE.
        </p>
        <p>
          WE ARE NOT LIABLE FOR ANY DAMAGES OR INJURY THAT RESULT FROM YOUR USE
          OF OUR WEB SITES. THIS INCLUDES, BUT IS NOT LIMITED TO, DAMAGES OR
          INJURY CAUSED BY: USE OF OR INABILITY TO USE OUR WEB SITES OR ANY SITE
          TO WHICH YOU LINK FROM OUR SITES; ERRORS OR OMISSIONS ON OUR SITES;
          INTERRUPTIONS OF OR DEFECTS IN OUR SITES; OR, ANY COMPUTER VIRUS,
          MALWARE OR HARMFUL COMPONENTS IN OUR SITES.
        </p>
        <p>
          YOU AGREE THAT WE ARE NOT LIABLE TO YOU UNDER ANY CAUSE OF ACTION FOR
          ANY DAMAGES OR INJURY CAUSED BY OR RESULTING FROM THE USE OF, OR
          INABILITY TO USE, THIS WEB SITE OR THE WEB PAGE CONTENT ON OR
          AVAILABLE THROUGH THIS WEB SITE. YOU AGREE THAT WE ARE NOT LIABLE EVEN
          IF WE HAVE BEEN NEGLIGENT OR IF WE OR OUR AUTHORIZED REPRESENTATIVE
          HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
        </p>
        <p>
          IN CERTAIN STATES THE LAW MAY NOT ALLOW US TO LIMIT OR EXCLUDE
          LIABILITY FOR INCIDENTAL OR CONSEQUENTIAL DAMAGES OR DISCLAIM
          WARRANTIES, THEREFORE, THE ABOVE LIMITATIONS OF LIABILITY MAY NOT
          APPLY TO YOU AND YOU MAY HAVE THE RIGHT TO RECOVER INCIDENTAL OR
          CONSEQUENTIAL DAMAGES. OUR LIABILITY TO YOU FOR ALL LOSSES, DAMAGES,
          INJURIES, AND CLAIMS (WHETHER ALLEGED UNDER THE TERMS OF A CONTRACT,
          ALLEGEDLY CAUSED BY NEGLIGENCE OR OTHER WRONGFUL CONDUCT, OR ALLEGED
          UNDER ANY OTHER LEGAL THEORY) WILL BE LIMITED TO THE AMOUNT YOU PAID
          TO ACCESS OUR WEB SITES.
        </p>
        <h4>
          What happens when this information collection and use policy changes?
        </h4>
        <p>
          From time to time we may change our information collection and use
          policy. The latest version of this policy will be posted here. You
          should periodically check here for the most current version of this
          policy. Any changes to this policy will not be retroactively applied.
          You understand and agree that your website use and access is governed
          by the policy that is effective at the time of your access or use of
          the website.
        </p>
        <h4>
          Who can I contact if I have questions regarding this web site use
          policy?
        </h4>
        <p>
          Questions regarding this web site information collection and use
          policy should be directed to us by email to
          OnlinePrivacy@ClaytonHomes.com or by writing to us at Online Privacy
          Department, 5000 Clayton Rd., Maryville, TN 37804.
        </p>
      </div>
    </>
  );
};

export const PrivacyContent = () => {
  return (
    <div id="privacy">
      <p className="revision">rev. 06/2022</p>
      <p className="download">
        Download our{' '}
        <a
          href="https://p.widencdn.net/a7izzh/Privacy-Notice"
          target="_blank"
          rel="noreferrer"
        >
          Privacy Policy
        </a>{' '}
        (PDF)
      </p>

      <div>
        <div>
          <h4>FACTS</h4>
          <h5>
            WHAT DO VANDERBILT, HOMEFIRST, CMH, PROPERTIES, AND WIMBLEDON DO
            WITH YOUR PERSONAL INFORMATION?
          </h5>
        </div>
      </div>
      <div>
        <div>
          <h5>Why?</h5>
          <p>
            Financial companies choose how they share your personal information.
            Federal law gives consumers the right to limit some but not all
            sharing. Federal law also requires us to tell you how we collect,
            share, and protect your personal information. Please read this
            notice carefully to understand what we do.
          </p>
        </div>
      </div>
      <div>
        <div>
          <h5>What?</h5>
          <p>
            The types of personal information we collect and share depend on the
            product or service you have with us. This information can include:
          </p>
          <ul>
            <li>Social Security number and income</li>
            <li>Account balances and assets</li>
            <li>Credit history and credit scores</li>
          </ul>
        </div>
      </div>
      <div>
        <div>
          <h5>How?</h5>
          <p>
            All financial companies need to share customers
            {String.fromCharCode(39)} personal information to run their everyday
            business. In the section below, we list the reasons financial
            companies can share their customers{String.fromCharCode(39)}{' '}
            personal information; the reasons Vanderbilt, HomeFirst, CMH,
            Properties, and Wimbledon choose to share; and whether you can limit
            this sharing.
          </p>
        </div>
      </div>
      <table className="privacy-table margin-top">
        <tbody>
          <tr>
            <td className="reasons-heading">
              <h4>Reasons we can share your personal information</h4>
            </td>
            <td className="do-we-share-heading">
              <h4>
                Do Vanderbilt, HomeFirst, CMH, Properties, and Wimbledon share?
              </h4>
            </td>
            <td className="limit-sharing-heading">
              <h4>Can you limit this sharing?</h4>
            </td>
          </tr>
          <tr>
            <td className="reasons">
              <p>
                <strong>For our everyday business purposes -</strong>
                <br /> such as to process your transactions, maintain your
                account(s), respond to court orders and legal investigations, or
                report to credit bureaus.
              </p>
            </td>
            <td className="do-we-share">
              <p>Yes</p>
            </td>
            <td className="limit-sharing">
              <p>No</p>
            </td>
          </tr>
          <tr>
            <td className="reasons">
              <p>
                <strong>For our marketing purposes -</strong>
                <br />
                to offer our products and services to you
              </p>
            </td>
            <td className="do-we-share">
              <p>Yes</p>
            </td>
            <td className="limit-sharing">
              <p>No</p>
            </td>
          </tr>
          <tr>
            <td className="reasons">
              <p>
                <strong>
                  For joint marketing with other financial companies
                </strong>
              </p>
            </td>
            <td className="do-we-share">
              <p>Yes</p>
            </td>
            <td className="limit-sharing">
              <p>No</p>
            </td>
          </tr>
          <tr>
            <td className="reasons">
              <p>
                <strong>
                  For our affiliates{String.fromCharCode(39)} everyday business
                  purposes -
                </strong>
                <br />
                information about your transactions and experiences
              </p>
            </td>
            <td className="do-we-share">
              <p>Yes</p>
            </td>
            <td className="limit-sharing">
              <p>No</p>
            </td>
          </tr>
          <tr>
            <td className="reasons">
              <p>
                <strong>
                  For our affiliates{String.fromCharCode(39)} everyday business
                  purposes -
                </strong>
                <br />
                information about your creditworthiness
              </p>
            </td>
            <td className="do-we-share">
              <p>Yes</p>
            </td>
            <td className="limit-sharing">
              <p>Yes</p>
            </td>
          </tr>
          <tr>
            <td className="reasons">
              <p>
                <strong>For our affiliates to market to you</strong>
              </p>
            </td>
            <td className="do-we-share">
              <p>Yes</p>
            </td>
            <td className="limit-sharing">
              <p>Yes</p>
            </td>
          </tr>
          <tr>
            <td className="reasons">
              <p>
                <strong>For nonaffiliates to market to you</strong>
              </p>
            </td>
            <td className="do-we-share">
              <p>Yes</p>
            </td>
            <td className="limit-sharing">
              <p>Yes</p>
            </td>
          </tr>
        </tbody>
      </table>
      <div>
        <div>
          <h5>To limit our sharing</h5>
          <ul>
            <li>
              Call toll-free <a href="tel:8778265294">877-826-5294</a> -our menu
              will prompt you through your choices or
            </li>
            <li>
              Visit us online:{' '}
              <a href="https://www.optoutoday.com">http://www.optoutoday.com</a>
            </li>
          </ul>
          <p>
            <em>Please note:</em>
            <br />
            If you are a <em>new</em> customer, it may take up to 48 hours for
            your information to enter our systems. We can begin sharing your
            information 30 days from the date the information is added which
            will be on or after the date we sent this notice. When you are no
            longer our customer, we continue to share your information as
            described in this notice.
          </p>
          <p>
            However, once your information has been added to our systems, you
            can contact us at any time to limit our sharing.
          </p>
          <h5>Questions?</h5>
          <p>
            Call toll-free <a href="tel:8778265310">877-826-5310</a>.
          </p>
        </div>
      </div>
      <div>
        <div>
          <h4>Who we are</h4>
          <h5>Who is providing this notice?</h5>
          <p>
            Vanderbilt Mortgage and Finance, Inc. also doing business as
            Silverton Mortgage (Vanderbilt); HomeFirst Agency, Inc., HomeFirst
            Insurance Agency, and Silverton Insurance Solutions (HomeFirst); CMH
            Homes, Inc. (CMH); Clayton Properties Group, Inc. (Properties);
            Wimbledon Realty, LLC and Wimbledon Properties, LLC (Wimbledon).
          </p>
        </div>
      </div>
      <div>
        <div>
          <h4>What we do</h4>
          <h5>
            How do Vanderbilt, HomeFirst, CMH, Properties, and Wimbledon protect
            my personal information?
          </h5>
          <p>
            To protect your personal information from unauthorized access and
            use, we use security measures that comply with federal law. These
            measures include computer safeguards and secured files and
            buildings.
          </p>
          <h5>
            How do Vanderbilt, HomeFirst, CMH, Properties, and Wimbledon collect
            my personal information?
          </h5>
          <p>We collect your personal information, for example, when you</p>
          <ul>
            <li>Apply for a loan or apply for insurance.</li>
            <li>
              Give us your income information or give us your contact
              information.
            </li>
            <li>Give us your employment history.</li>
            <li>
              We also collect your personal information from others, such as
              credit bureaus, affiliates, or other companies.
            </li>
          </ul>
          <h5>Why can{String.fromCharCode(39)}t I limit all sharing?</h5>
          <p>Federal law gives you the right to limit only</p>
          <ul>
            <li>
              Sharing for affiliates{String.fromCharCode(39)} everyday business
              purposes - information about your creditworthiness.
            </li>
            <li>Affiliates from using your information to market to you.</li>
            <li>Sharing for nonaffiliates to market to you.</li>
          </ul>
          <p>
            State laws and individual companies may give you additional rights
            to limit sharing. See below for more on your rights under state law.
          </p>
          <h5>
            What happens when I limit sharing for an account I hold jointly with
            someone else?
          </h5>
          <p>Your choices will apply to everyone on your account.</p>
        </div>
      </div>
      <h4>Definitions</h4>
      <div>
        <div>
          <h5>Affiliates</h5>
          <p>
            Companies related by common ownership or control. They can be
            financial and nonfinancial companies.
          </p>
          <ul>
            <li>
              Our affiliates include financial companies such as Vanderbilt
              Mortgage and Finance, Inc., HomeFirst Agency, Inc., CMH Homes,
              Inc., Clayton Properties Group, Inc., Wimbledon Realty, LLC,
              Wimbledon Properties, LLC, 21st Mortgage Corporation, and
              Parkplace Homes, LLC, and nonfinancial companies such as CMH
              Manufacturing, Inc., and CMH Manufacturing West, Inc.
            </li>
          </ul>
        </div>
      </div>
      <div>
        <div>
          <h5>Nonaffiliates</h5>
          <p>
            Companies not related by common ownership or control. They can be
            financial and nonfinancial companies.
          </p>
          <ul>
            <li>
              Nonaffiliates we share with can include mortgage companies,
              insurance companies, direct marketing companies, and nonprofit
              organizations.
            </li>
          </ul>
        </div>
      </div>
      <div>
        <div>
          <h5>Joint Marketing</h5>
          <p>
            A formal agreement between nonaffiliated financial companies that
            together market financial products or services to you.
          </p>
          <ul>
            <li>Our joint marketing partners include mortgage companies.</li>
          </ul>
        </div>
      </div>
      <h2>Other Important Information</h2>
      <p>
        <strong>California Residents</strong>: We will not share your
        information for joint marketing with other financial companies, or for
        nonaffiliates to market to you.
      </p>
      <p>
        <strong>North Dakota and Vermont Residents</strong>: We will not share
        your information for joint marketing with other financial companies, for
        our affiliates{String.fromCharCode(39)} everyday business purposes
        (information about your creditworthiness), for our affiliates to market
        to you, or for nonaffiliates to market to you.
      </p>
      <p>
        <strong>Notice of Information Practices</strong>: Personal information
        about you may be collected from others in connection with your
        application for insurance and subsequent policy renewals. This may
        include obtaining a credit report and loss history report. In certain
        circumstances, such information may be disclosed to third parties
        without your authorization. After proper identification, you have a
        right to review and correct all personal information we collected about
        you. A more detailed description of your rights and our information
        practices may be obtained by contacting us at 1-877-826-5310. This
        Notice is applicable for risks insured in Arizona, California,
        Connecticut, Georgia, Illinois, Kansas, Maine, Massachusetts, Minnesota,
        Montana, Nevada, New Jersey, North Carolina, Ohio, Oregon, Virginia and
        Wisconsin.
      </p>
    </div>
  );
};

export const LegalTermsAccountsContent = () => {
  return (
    <section>
      <p>Effective date: January, 2021</p>
      <p>
        Clayton ("we", or "us") offers you the Favorites and My Clayton Built
        Home<sup>&trade;</sup> service, located at{' '}
        <a href="https://www.claytonhomes.com/favorites">
          https://www.claytonhomes.com/favorites
        </a>
        , and the My Clayton Built Home<sup>&trade;</sup> mobile application,
        available at{' '}
        <a href="https://www.claytonhomes.com">https://www.claytonhomes.com</a>,
        along with all of the features and functions of the website and app
        (collectively the "Services"). These Terms of Use ("Terms") apply to
        your use of the Services. These Terms constitute a legally binding
        agreement between you and us. You must be 18 years old or the age of
        majority in your jurisdiction in order to use our Services. If you are
        under 18 years old or the age of majority in your jurisdiction, then you
        may only use the Services with your parent or legal guardian's
        permission. By accessing or using our Services, you agree that you (or
        your parent or legal guardian) have read, understand, and are bound by
        the terms and conditions set forth herein. IF YOU (OR YOUR PARENT OR
        LEGAL GUARDIAN) DO NOT AGREE TO THESE TERMS, YOU MAY NOT USE OR ACCESS
        THE SERVICES.
      </p>
      <h5>General Description</h5>
      <p>
        The Services allow you to add pictures to your own personal Favorites or
        to the My Clayton Built Home<sup>&trade;</sup> app. To add pictures, you
        can either upload your own photos or you can identify favorite images
        displayed on the{' '}
        <a href="https://www.claytonhomes.com">claytonhomes.com</a> website or
        within the app (the "Images") by clicking on the heart logo located at
        the bottom left of the Image. You will be able to share your favorite
        images with other people and customize who will be able to view your
        Images. Your Images will always be viewable by Clayton Homes retail home
        centers that you have visited and provided your email address to and
        Clayton Homes retail home centers that we provided your email address to
        when you created an account for the Services and/or when you submitted a
        request for product information. The app also allows you to bookmark
        favorite articles from the claytonhomes.com website, Browse homes in
        inventory, and to take a Smart Tour of our model homes, in which a
        beacon transmitter will connect with your mobile device to provide you
        with information about a home you are touring in real time.
      </p>
      <h5>Registration</h5>
      <p>
        In order to access and use other parts of the Services, you will be
        required to register an account with us. The Services may allow you to
        create an account through a social media service. You are solely
        responsible for any activity that occurs on your account and for
        maintaining the confidentiality of your password. It is your sole
        responsibility to provide and maintain accurate account information. We
        reserve the right to cancel your account at any time for any reason
        without prior notice to you. If there has been an unauthorized use of
        your password or account, please notify us immediately.
      </p>
      <p>
        When you register an account with us, you may be required to provide
        some of your personal information. By using the Services and providing
        us with your personal information, you also accept our "Website
        information collection and use practices and Web site terms and
        conditions" , available at{' '}
        <a href="https://www.claytonhomes.com/legal">
          https://www.claytonhomes.com/legal
        </a>
        , which is incorporated into these Terms.
      </p>
      <h5>Ownership</h5>
      <p>
        Unless otherwise stated herein, we and our licensors are the sole owners
        of the Services and all of their content, including without limitation,
        the Images and all information, services, features, functions,
        copyrights, trademarks, service marks, and other intellectual property
        rights contained within the Services. You agree that all right, title,
        and interest in the Services will remain ours or our licensors'
        exclusive property. Nothing in these Terms gives you a right to
        reproduce, copy, distribute, sell, broadcast, license, or otherwise use
        the Images, the Clayton name or any of our trademarks, logos, domain
        names, or other distinctive brand features. You may not modify, rent,
        lease, sell, distribute, or create derivative works based on the
        Services unless we have given you prior written consent to do so. You
        may only use the Services for personal, non-commercial purposes.
      </p>
      <h5>Use Restrictions</h5>
      <p>
        While using the Services you agree to comply with all applicable laws,
        rules and regulations. In addition, we expect users of the Services to
        respect the rights and dignity of others. Your use of the Services is
        conditioned on your full compliance with these Terms including, without
        limitation, the rules of conduct set forth in this section; your failure
        to comply with such rules may result in termination of your access to
        the Services pursuant to these Terms. You agree that when using the
        Services you will not:
      </p>
      <ul>
        <li>
          Transmit by any means any software, virus, malware, program, code,
          file, or other material intended to interrupt, disrupt, alter,
          destroy, or limit any part of the Services;
        </li>
        <li>
          Use any robot, spider, script, or any manual or automated application
          or means to extract, download, retrieve, index, mine, scrape,
          reproduce, or circumvent the presentation, operation, or intended use
          of any feature, function, or part of the Services;
        </li>
        <li>
          Frame or mirror any part of the Services without Clayton's express
          prior written consent;
        </li>
        <li>
          Modify, adapt, translate, reverse engineer, decompile or disassemble
          any portion of the Services;
        </li>
        <li>
          Submit or post any offensive, defamatory, threatening, indecent,
          hateful, racist, sexist, pornographic, or otherwise inappropriate or
          obscene content (as determined by us in our sole discretion);
        </li>
        <li>
          Copy, download, distribute, transmit, upload, or transfer content from
          the Services or the personal information of others without our prior
          written permission or authorization;
        </li>
        <li>
          Resell, sub-license, or lease any of the content on the Services;
        </li>
        <li>
          Use the Services to make unsolicited offers, requests, advertisements,
          or spam;
        </li>
        <li>
          Impersonate or pretend to be anyone else but you; falsely state or
          otherwise misrepresent your affiliation with any person or entity in
          connection with the Services; or express or imply that we endorse any
          statement you make;
        </li>
        <li>
          Violate or infringe upon the privacy, publicity, intellectual
          property, or other proprietary rights of third parties; or
        </li>
        <li>
          Engage in any activity that is criminal or tortious in nature, or
          otherwise violates the law or rights of another including, without
          limitation, hacking, phishing, fraud, stalking, defaming, abusing,
          harassing, or threatening.
        </li>
      </ul>
      <h5>User Generated Content</h5>
      <p>
        The Services permit you to upload, exchange, share and post content
        ("User Generated Content"), including, without limitation, images and
        notes. By providing User Generated Content, you grant us and our
        affiliates and our service providers, and each of their and our
        respective licensees, successors and assigns the right to use,
        reproduce, modify, perform, display, distribute and otherwise disclose
        to third parties any such material for any purpose. You represent and
        warrant that you own or control all rights in and to your User Generated
        Content and have the right to grant the license granted above to us and
        our affiliates and our service providers, and each of their and our
        respective licensees, successors and assigns. User Generated Content on
        the Services is not independently verified by Clayton. Therefore, your
        reliance on User Generated Content is at your own risk. Because Clayton
        has no control over User Generated Content, you acknowledge and agree
        that Clayton is not responsible for the accuracy or availability of User
        Generated Content, and Clayton neither endorses nor is responsible or
        liable for any User Generated Content that appears on the Services.
        Clayton shall have the right (but not the obligation) to delete, remove,
        monitor, or edit User Generated Content and block links to the Services
        through technological or other means without prior notice.
      </p>
      <h5>Claims of Copyright Infringement</h5>
      <p>
        The Digital Millennium Copyright Act of 1998 (the "DMCA") provides
        recourse for copyright owners who believe that material appearing on the
        Internet infringes their rights under U.S. copyright law. To view our
        DMCA policy, visit our "Website information collection and use practices
        and Web site use terms and conditions", available at{' '}
        <a href="https://www.claytonhomes.com/legal">
          https://www.claytonhomes.com/legal
        </a>
        .
      </p>
      <h5>Disclaimer or Warranties</h5>
      <p>
        THE SERVICES ARE PROVIDED TO YOU "AS IS" AND "AS AVAILABLE" WITHOUT ANY
        WARRANTIES OF ANY KIND, WHETHER EXPRESS, IMPLIED OR STATUTORY. YOU AGREE
        THAT YOU MUST EVALUATE, AND THAT YOU BEAR ALL RISKS ASSOCIATED WITH, THE
        USE OF THE SERVICES, INCLUDING WITHOUT LIMITATION, ANY RELIANCE ON THE
        ACCURACY, COMPLETENESS OR USEFULNESS OF ANY MATERIALS AVAILABLE THROUGH
        THE SERVICES. CLAYTON DISCLAIMS ALL WARRANTIES WITH RESPECT TO THE
        SERVICES INCLUDING, BUT NOT LIMITED TO, THE WARRANTIES OF
        NONINFRINGEMENT, AND TITLE. CLAYTON MAKES NO WARRANTY THAT THE SERVICES
        WILL BE ERROR FREE OR UNINTERRUPTED, THAT THE INFORMATION OBTAINED FROM
        THE SERVICES WILL BE ACCURATE, COMPLETE, CURRENT, OR RELIABLE, THAT THE
        QUALITY OF THE SERVICES WILL BE SATISFACTORY TO YOU, OR THAT ERRORS OR
        DEFECTS WILL BE CORRECTED. CLAYTON MAKES NO GUARANTEE REGARDING THE
        RELIABILITY, ACCURACY, OR QUALITY OF ANY COMMUNICATION THAT IS POSTED ON
        THE SERVICES.
      </p>
      <h5>Limitation of Liability</h5>
      <p>
        TO THE FULLEST EXTENT PERMITTED BY LAW, CLAYTON SHALL NOT BE LIABLE TO
        YOU OR ANY OTHER PARTY FOR ANY CLAIM, LOSS OR DAMAGE, DIRECT OR
        INDIRECT, INCLUDING, WITHOUT LIMITATION, COMPENSATORY, CONSEQUENTIAL,
        INCIDENTAL, INDIRECT, SPECIAL, EXEMPLARY, OR PUNITIVE DAMAGES,
        REGARDLESS OF THE FORM OF ACTION OR BASIS OF ANY CLAIM. YOU SPECIFICALLY
        ACKNOWLEDGE THAT CLAYTON SHALL NOT BE LIABLE TO YOU FOR YOUR
        COMMUNICATIONS. CLAYTON SHALL NOT BE LIABLE FOR ANY BREACH OF SECURITY
        ASSOCIATED WITH THE TRANSMISSION OF INFORMATION THROUGH THE SERVICES OR
        ANY LINKED SERVICES, OR FOR ANY INFORMATION OR PRODUCTS, OBTAINED
        THROUGH USE OF THE SERVICES, OR OTHERWISE ARISING OUT OF THE USE OF THE
        SAME, REGARDLESS OF THE FORM OF ACTION OR BASIS OF ANY CLAIM. SOME
        JURISDICTIONS DO NOT ALLOW CERTAIN EXCLUSIONS OF WARRANTIES OR
        LIMITATIONS ON DAMAGES, SO SOME OF THESE EXCLUSIONS AND LIMITATIONS MAY
        NOT APPLY TO YOU. IF YOU HAVE A DISPUTE WITH CLAYTON OR ARE DISSATISFIED
        WITH THE SERVICES, TERMINATION OF YOUR USE OF THE SERVICES IS YOUR SOLE
        REMEDY. CLAYTON HAS NO OTHER OBLIGATION, LIABILITY, OR RESPONSIBILITY TO
        YOU.
      </p>
      <p>
        NEW JERSEY RESIDENTS: THIS PROVISION CONCERNING THE EXCLUSION OR
        LIMITATION OF CERTAIN DAMAGES IS NOT APPLICABLE IN NEW JERSEY WITH
        RESPECT TO STATUTORY DAMAGES, PUNITIVE DAMAGES, LOSS OF DATA, AND LOSS
        OF OR DAMAGE TO PROPERTY.
      </p>
      <h5>Notice for New Jersey residents</h5>
      <p>
        No provision in these Terms and Conditions shall apply to any consumer
        in New Jersey if the provision limits redress for/under:
        (i)&nbsp;Clayton's tortious actions (e.g., negligence, failure to
        exercise a basic standard of care, failure to avoid creating an
        unreasonable risk of harm); (ii)&nbsp;the New Jersey Products Liability
        Act, N.J.S.A. 2A:58C-1, et seq. (i.e., the statutorily imposed duty to
        refrain from manufacturing and selling dangerous products, with the
        possibility of punitive damages for violations thereof); (iii)&nbsp;the
        New Jersey Punitive Damages Act, N.J.S.A. 2A:15-5.9, et seq. (i.e., the
        statutory right to pursue punitive damages in the event of harm caused
        by actual malice, wanton and willful disregard, reckless indifference);
        (iv)&nbsp;the New Jersey Uniform Commercial Code (i.e., a comprehensive
        statutory regime governing the rights and duties of buyers and sellers
        with respect to contracts for the sale of goods, with the possibility of
        damages for economic and property harm); and (v)&nbsp;Clayton's failure
        to reasonably protect against harm arising from certain criminal acts of
        third parties (e.g., computer hacking and identity theft, as regulated
        by the Federal Trade Commission and the Federal Communications
        Commission, and as governed by the New Jersey Identity Theft Protection
        Act, N.J.S.A.56:8-161, et seq., and the New Jersey Consumer Fraud Act,
        N.J.S.A. 56:8-3, et seq.).
      </p>
      <h5>Indemnity</h5>
      <p>
        You agree to defend, indemnify and hold harmless Clayton, and its
        respective employees, officers, directors, agents, representatives,
        licensors, suppliers and service providers from and against all claims,
        losses, costs and expenses (including attorney's fees) arising out of
        (a)&nbsp;your use of, or activities in connection with the Services; or
        (b)&nbsp;any violation of these Terms by you. We reserve the right to
        assume all or any part of the defense of any such claims and
        negotiations for settlement and you agree to fully cooperate with us in
        doing so.
      </p>
      <h5>Dispute Resolution</h5>
      <p>
        These Terms will be construed and enforced under the laws of the State
        of Tennessee. You agree that United States District Court for the
        Eastern District of Tennessee (Knoxville Division) shall be the
        exclusive forum for any dispute arising out of these Terms and the
        parties hereby consent to the personal jurisdiction of such courts and
        agree to waive any right to claim that the United States District Court
        for the Eastern District of Tennessee (Knoxville Division) is an
        inconvenient forum. If the court in your country will not apply
        Tennessee law, or if the courts in your country will not permit you to
        consent to the jurisdiction of United States District Court for the
        Eastern District of Tennessee (Knoxville Division), then your local law
        and jurisdiction will apply to such disputes related to these Terms. You
        agree that you will not file a class action, or participate in a class
        action against us.
      </p>
      <h5>Termination</h5>
      <p>
        We may immediately, without prior notice, suspend or terminate your use
        of and access to the Services, at our sole discretion, for any reason,
        whether with or without cause or warning, and without liability. You may
        terminate these Terms by ceasing your use of the Services.
      </p>
      <h5>Severability</h5>
      <p>
        If the application of any provision of these Terms to any particular
        facts or circumstances shall for any reason be held to be invalid,
        illegal or unenforceable by a court, arbitrator or other tribunal of
        competent jurisdiction, then (a)&nbsp;the validity, legality and
        enforceability of such provision as applied to any other particular
        facts or circumstances, and the other provisions of this Terms, shall
        not in any way be affected or impaired thereby and (b)&nbsp;such
        provision shall be enforced to the maximum extent possible so as to
        effect the intent of the parties.
      </p>
      <h5>Changes</h5>
      <p>
        We reserve the right to change any part of the Services, including these
        Terms, at any time. If we change these Terms, we will update the
        Effective Date listed above. Your continued use of the Services means
        that you agree with our updated Terms. If you do not agree with our
        updated Terms, you may not use our Services.
      </p>
      <h5>Questions or Comments</h5>
      <p>
        If you have any questions or comments about these Terms or the Services,
        please contact us by email to OnlinePrivacy@ClaytonHomes.com or by
        writing to us at Online Privacy Department, 5000 Clayton Rd., Maryville,
        TN 37804.
      </p>
    </section>
  );
};

export const DispatchTermsOfUse = () => {
  return (
    <section>
      <h1 className="page-heading">Clayton Dispatch Terms of Use</h1>
      <p>
        <b>Last Modified:</b> August 10, 2023
      </p>
      <h4>Background</h4>
      <p>
        Clayton utilizes Dispatch, a communications tool designed to enhance the
        Company&apos;s interactions with its contractors, retail partners, and
        customers. Dispatch is available through a mobile application as well as
        a website browser and is intended for use by contractors and retailers
        to perform warranty services related to Clayton built homes.
      </p>
      <h5 className="underline-header">Acceptance of the Terms of Use</h5>
      <p>
        These terms of use are entered into by and between You and the Clayton
        Homes Family of Companies (“<strong>Clayton</strong>,” “
        <strong>Company</strong>,” “<strong>we</strong>,” or “
        <strong>us</strong>”). The following terms and conditions (“
        <strong>Terms of Use</strong>”) govern your access to and use of the
        Dispatch application, as related to performance of warranty services on
        Clayton built homes, whether through a mobile application or website,
        including any content, functionality, and services offered on or through
        the application (“Dispatch or the “App”). Use of the App, as related to
        performance of warranty services on Clayton built homes, is limited to
        registered contractors and retailers.
      </p>
      <p>
        Please read the Terms of Use carefully before you start to use the App.{' '}
        <strong>
          By using the App, you accept and agree to be bound and abide by these
          Terms of Use and our Privacy Policy, incorporated herein by reference.
        </strong>{' '}
        If you do not want to agree to these Terms of Use or the Privacy Policy,
        you must not access or use the App.{' '}
      </p>
      <p>
        This App is offered and available only to registered contractors and
        retailers who are 18 years of age or older, or the age of majority in
        their jurisdiction. By using this App, you represent and warrant that
        you are of legal age to form a binding contract with the Company and
        meet all of the foregoing eligibility requirements. If you do not meet
        all of these requirements, you must not access or use the App.
      </p>
      <h5 className="underline-header">Changes to the Terms of Use</h5>
      <p>
        We may revise and update these Terms of Use from time to time in our
        sole discretion. While we will provide notice of material changes in
        accordance with applicable law, all other changes are effective
        immediately when we post them, and apply to all access to and use of the
        App thereafter. However, any changes to the dispute resolution
        provisions set out in <em>Governing Law and Jurisdiction</em> will not
        apply to any disputes for which the parties have actual notice before
        the date the change is posted on the App.
      </p>
      <p>
        Your continued use of the App following the posting of revised Terms of
        Use means that you accept and agree to the changes. You are expected to
        check this page from time to time so you are aware of any changes, as
        they are binding on you.
      </p>
      <h5 className="underline-header">General Requirements</h5>
      <p>
        This App is offered for convenience only and is not required for you to
        perform the functions of your assignment. By accepting these Terms of
        Use, You agree as follows:
      </p>
      <ul>
        <li>
          You will not be compensated for accessing the App during or after work
          hours.
        </li>
        <li>
          You have read the Content Standards in this Terms of Use and
          understand the App is an extension of the workplace as it applies to
          Clayton Team Members.
        </li>
        <li>You will not use the App while driving.</li>
        <li>
          Use of the App is completely voluntary and the Company will not
          reimburse any expenses associated with using the App, such as cellular
          phone bills and data usage.
        </li>
        <li>
          You will only use the App if You are an active Clayton team member,
          Independent Retailer, or contractor performing warranty services
          related to Clayton built homes.
        </li>
        <li>
          You acknowledge and agree that all content available on or through the
          app is the confidential information of Clayton and you will not share
          any App content outside of the context of your particular assignment
          with anyone unrelated to the assignment.
        </li>
      </ul>
      <h5 className="underline-header">
        Accessing the App and Account Security
      </h5>
      <p>
        We reserve the right to withdraw or amend this App, and any service or
        material we provide on the App, in our sole discretion without notice.
        We will not be liable if for any reason all or any part of the App is
        unavailable at any time or for any period. From time to time, we may
        restrict access to some parts of the App, or the entire App, to users,
        including registered users.
      </p>
      <p>
        You are responsible for making all arrangements necessary for you to
        have access to the App.
      </p>
      <p>
        To access the App or some of the resources it offers, you may be asked
        to provide certain registration details or other information. It is a
        condition of your use of the App that all the information you provide on
        the App is correct, current, and complete. You agree that all
        information you provide to register with this App or otherwise,
        including, but not limited to, through the use of any interactive
        features on the App, is governed by the Privacy Policy, and you consent
        to all actions we take with respect to your information consistent with
        our Privacy Policy.
      </p>
      <p>
        If you choose, or are provided with, a user name, password, or any other
        piece of information as part of our security procedures, you must treat
        such information as confidential, and you must not disclose it to any
        other person or entity. You also acknowledge that your account is
        personal to you and agree not to provide any other person with access to
        this App or portions of it using your user name, password, or other
        security information. You agree to notify us immediately of any
        unauthorized access to or use of your user name or password or any other
        breach of security. You also agree to ensure that you exit from your
        account at the end of each session. You should use particular caution
        when accessing your account from a public or shared computer so that
        others are not able to view or record your password or other personal
        information. You should only create an account for your use only and
        should not create an account for others.
      </p>
      <p>
        We have the right to disable any user name, password, or other
        identifier, whether chosen by you or provided by us, at any time in our
        sole discretion for any or no reason, including if, in our opinion, you
        have violated any provision of these Terms of Use.
      </p>
      <h5 className="underline-header">Intellectual Property Rights</h5>
      <p>
        The App and its entire contents, features, and functionality (including
        but not limited to all information, software, text, displays, images,
        video, and audio, and the design, selection, and arrangement thereof)
        are owned by Dispatch, its licensors, which includes the Company, or
        other providers of such material and are protected by United States and
        international copyright, trademark, patent, trade secret, and other
        intellectual property or proprietary rights laws.
      </p>
      <p>
        You must not reproduce, distribute, modify, create derivative works of,
        publicly display, publicly perform, republish, download, store, or
        transmit any of the material on the App, except as follows:
      </p>
      <ul>
        <li>
          Your computer may temporarily store copies of such materials in RAM
          incidental to your accessing and viewing those materials.
        </li>
        <li>
          You may store files that are automatically cached by your Web browser
          for display enhancement purposes.
        </li>
      </ul>
      <p>You must not:</p>
      <ul>
        <li>Modify copies of any materials from this App.</li>
        <li>
          Use any illustrations, photographs, video or audio sequences, or any
          graphics separately from the accompanying text.
        </li>
        <li>
          Delete or alter any copyright, trademark, or other proprietary rights
          notices from copies of materials from this App.
        </li>
        <li>
          Translate, adapt, or otherwise create derivative works or
          improvements, whether or not patentable, of the App.
        </li>
      </ul>
      <p>
        If you print, copy, modify, download, or otherwise use or provide any
        other person with access to any part of the App in breach of the Terms
        of Use, your right to use the App will stop immediately and you must, at
        our option, return or destroy any copies of the materials you have made.
        No right, title, or interest in or to the App or any content on the App
        is transferred to you, and all rights not expressly granted are reserved
        by the Company. Any use of the App not expressly permitted by these
        Terms of Use is a breach of these Terms of Use and may violate
        copyright, trademark, and other laws.
      </p>
      <h5 className="underline-header">Trademarks</h5>
      <p>
        The Company name and all related names, logos, product and service
        names, designs, and slogans are trademarks of the Company or its
        affiliates or licensors. You must not use such marks without the prior
        written permission of the Company. All other names, logos, product and
        service names, designs, and slogans on this App are the trademarks of
        their respective owners.
      </p>
      <h5 className="underline-header">Prohibited Uses</h5>
      <p>
        You may use the App only for lawful purposes and Clayton grants you a
        limited, non-exclusive, and nontransferable license to download,
        install, and use the App in accordance with these Terms.
      </p>
      <p>You agree not to use the App:</p>
      <ul>
        <li>
          In any way that violates any applicable federal, state, local, or
          international law or regulation (including, without limitation, any
          laws regarding the export of data or software to and from the US or
          other countries).
        </li>
        <li>
          To send, knowingly receive, upload, download, use, or re-use any
          material that does not comply with the Content Standards set out in
          these Terms of Use.
        </li>
        <li>
          To transmit, or procure the sending of, any advertising or promotional
          material, including any "junk mail," "chain letter," "spam," or any
          other similar solicitation.
        </li>
        <li>
          To impersonate or attempt to impersonate the Company, a Company
          employee, another user, or any other person or entity (including,
          without limitation, by using email addresses or user names associated
          with any of the foregoing).
        </li>
        <li>
          To engage in any other conduct that restricts or inhibits anyone's use
          or enjoyment of the App, or which, as determined by us, may harm the
          Company or users of the App, or expose them to liability.
        </li>
        <li>
          To access or misuse any information regarding warranty services
          unrelated to homes manufactured by Clayton and its affiliates.
        </li>
      </ul>
      <p>Additionally, you agree not to:</p>
      <ul>
        <li>
          Use the App in any manner that could disable, overburden, damage, or
          impair the App or interfere with any other party's use of the App,
          including their ability to engage in real time activities through the
          App.
        </li>
        <li>
          Use any robot, spider, or other automatic device, process, or means to
          access the App for any purpose, including monitoring or copying any of
          the material on the App.
        </li>
        <li>
          Use any manual process to monitor or copy any of the material on the
          App, or for any other purpose not expressly authorized in these Terms
          of Use, without our prior written consent.
        </li>
        <li>
          Use any device, software, or routine that interferes with the proper
          working of the App.
        </li>
        <li>
          Introduce any viruses, Trojan horses, worms, logic bombs, or other
          material that is malicious or technologically harmful.
        </li>
        <li>
          Attempt to gain unauthorized access to, interfere with, damage, or
          disrupt any parts of the App, the server on which the App is stored,
          or any server, computer, or database connected to the App.{' '}
        </li>
        <li>
          Attack the App via a denial-of-service attack or a distributed
          denial-of-service attack.
        </li>
        <li>
          Otherwise attempt to interfere with the proper working of the App.
        </li>
        <li>
          Reverse engineer, disassemble, decompile, decode, or otherwise attempt
          to derive or gain access to the source code of the App or any part
          thereof.
        </li>
        <li>
          Rent, lease, lend, sell, sublicense, assign, distribute, publish,
          transfer, or otherwise make available the App, or any features or
          functionality of the App, to any third party for any reason, including
          by making the App available on a network where they are capable of
          being accessed by more than one device at any time.
        </li>
        <li>
          Remove, disable, circumvent, or otherwise create or implement any
          workaround to any copy protection, rights management, or security
          features in or protecting the App.
        </li>
        <li>
          Use the App in, or in association with, the design, construction,
          maintenance, or operation of any hazardous environments or systems,
          including any power generation systems; aircraft navigation or
          communication systems, air traffic control systems, or any other
          transport management systems; safety-critical applications, including
          medical or life-support systems, vehicle operation applications or any
          police, fire, or other safety response systems; and military or
          aerospace applications, weapons systems, or environments.
        </li>
      </ul>
      <h5 className="underline-header">
        Monitoring and Enforcement: Termination
      </h5>
      <p>We have the right to:</p>
      <ul>
        <li>
          Take appropriate legal action, including without limitation, referral
          to law enforcement, for any illegal or unauthorized use of the App.{' '}
        </li>
        <li>
          Terminate or suspend your access to all or part of the App for any or
          no reason, including without limitation, any violation of these Terms
          of Use.
        </li>
        <li>
          Enforce, through your use of the App, other Company policies that
          govern team member conduct. To the extent other Company policies
          conflict with these Terms of Use, the other Company policies will
          control.
        </li>
      </ul>
      <p>
        Without limiting the foregoing, we have the right to cooperate fully
        with any law enforcement authorities or court order requesting or
        directing us to disclose the identity or other information of anyone
        posting any materials on or through the App. YOU WAIVE AND HOLD HARMLESS
        THE COMPANY AND ITS AFFILIATES, LICENSEES, AND SERVICE PROVIDERS FROM
        ANY CLAIMS RESULTING FROM ANY ACTION TAKEN BY THE THE FOREGOING PARTIES
        DURING, OR TAKEN AS A CONSEQUENCE OF, INVESTIGATIONS BY EITHER THE
        COMPANY/SUCH PARTIES OR LAW ENFORCEMENT AUTHORITIES.
      </p>
      <p>
        Clayton may terminate these Terms of Use or suspend your access to all
        or part of the App for any or no reason, including, without limitation,
        any violation of these Terms of Use, at any time without notice.
      </p>
      <p>
        Upon termination, all rights granted to you under these Terms of Use
        will also terminate, and you must cease all use of the App and delete
        all copies of the App.
      </p>
      <p>
        We also have the right to take appropriate legal action, including
        without limitation, referral to law enforcement, for any illegal or
        unauthorized use of the App.
      </p>
      <p>
        Termination will not limit any of Clayton's rights or remedies at law or
        in equity.
      </p>
      <h5 className="underline-header">Content Standards</h5>
      <p>
        These Content Standards apply to any use of the App. Without limiting
        the foregoing, users must not:
      </p>
      <ul>
        <li>
          Contain Share, post, forward, send, or communicate any material that
          is defamatory, obscene, indecent, abusive, offensive, harassing,
          violent, hateful, inflammatory, or otherwise objectionable.
        </li>
        <li>
          Promote sexually explicit or pornographic material, violence, or
          discrimination based on race, sex, religion, nationality, disability,
          sexual orientation, or age.
        </li>
        <li>
          Infringe any patent, trademark, trade secret, copyright, or other
          intellectual property or other rights of any other person.
        </li>
        <li>
          Violate the legal rights (including the rights of publicity and
          privacy) of others or contain any material that could give rise to any
          civil or criminal liability under applicable laws or regulations or
          that otherwise may be in conflict with these Terms of Use and our
          Privacy Policy.
        </li>
        <li>Be likely to deceive any person.</li>
        <li>
          Promote any illegal activity, or advocate, promote, or assist any
          unlawful act.
        </li>
        <li>
          Cause annoyance, inconvenience, or needless anxiety or be likely to
          upset, embarrass, alarm, or annoy any other person.
        </li>
        <li>
          Impersonate any person, or misrepresent your identity or affiliation
          with any person or organization.
        </li>
        <li>
          Involve commercial activities or sales, such as contests, sweepstakes,
          and other sales promotions, barter, or advertising.
        </li>
        <li>
          Give the impression that they emanate from or are endorsed by us or
          any other person or entity, if this is not the case.
        </li>
      </ul>
      <h5 className="underline-header">Copyright Infringement</h5>
      <p>
        <em>Reporting Claims of Copyright Infringement</em>
      </p>
      <p>
        We respect and are committed to protecting copyright and intellectual
        property rights of others and we expect users of our web sites to do the
        same. The Digital Millennium Copyright Act of 1998 ("
        <strong>DMCA</strong>"), Title 178 U.S.C.§512, provides recourse for
        copyright owners who believe that material displayed or used on our web
        sites infringes rights under copyright law. If you believe that any
        materials used or displayed on our web sites infringes your copyright,
        you may send us a notice requesting that the material be removed. To
        file a copyright infringement notice with us, you will need to send a
        written communication that includes substantially the following
        information:
      </p>
      <ul>
        <li>
          A physical or electronic signature of a person authorized to act on
          behalf of the owner of an exclusive right that is allegedly infringed.
        </li>
        <li>
          Identification of the copyrighted work claimed to have been infringed,
          or if multiple copyrighted works at a single online site are covered
          by a single notification, a representative list of such works at that
          site. Please describe the work and where possible include a copy of
          the URL location of an authorized version of the work.
        </li>
        <li>
          Identification of the material that is claimed to be infringing or to
          be the subject of infringing activity and that is to be removed or
          access to which is to be disabled, and information reasonably
          sufficient to permit us to locate the material on our App (providing
          URLs in your notice where the content is located will help us locate
          the content).
        </li>
        <li>
          Your contact information, name, address, telephone number, or
          electronic mail address at which you can be contacted.
        </li>
        <li>
          A statement that you, as the complaining party, have a good faith
          belief that use of the material in the manner complained of is not
          authorized by you, the copyright owner, your agent or the law.
        </li>
        <li>
          A statement that the information in the notice is accurate, and under
          penalty of perjury, that you are authorized to act on behalf of the
          owner of an exclusive right that is allegedly infringed.
        </li>
      </ul>
      <p>Provide this information to our designated DMCA Agent at:</p>
      <p>
        Online Privacy Department
        <br />
        5000 Clayton Rd.
        <br />
        Maryville, TN 37804
        <br />
      </p>
      <p>
        If you fail to comply with all of the requirements of Section 512(c)(3)
        of the DMCA, your DMCA Notice may not be effective.
      </p>
      <p>
        Please be aware that if you knowingly materially misrepresent that
        material or activity on the App is infringing your copyright, you may be
        held liable for damages (including costs and attorneys' fees) under
        Section 512(f) of the DMCA.
      </p>
      <p>
        <em>Counter Notification Procedures</em>
      </p>
      <p>
        If you believe that material you posted on the App was removed or access
        to it was disabled by mistake or misidentification, you may file a
        counter notification with us (a "<strong>Counter Notice</strong>") by
        submitting written notification to our copyright agent designated above.
        Pursuant to the DMCA, the Counter Notice must include substantially the
        following:
      </p>
      <ul>
        <li>Your physical or electronic signature.</li>
        <ul>
          <li>
            An identification of the material that has been removed or to which
            access has been disabled and the location at which the material
            appeared before it was removed or access disabled.{' '}
          </li>
        </ul>
        <li>
          Adequate information by which we can contact you (including your name,
          postal address, telephone number, and, if available, email address).
        </li>
        <ul>
          <li>
            A statement under penalty of perjury by you that you have a good
            faith belief that the material identified above was removed or
            disabled as a result of a mistake or misidentification of the
            material to be removed or disabled.
          </li>
        </ul>
        <li>
          A statement that you will consent to the jurisdiction of the Federal
          District Court for the judicial district in which your address is
          located (or if you reside outside the United States for any judicial
          district in which the App may be found) and that you will accept
          service from the person (or an agent of that person) who provided the
          App with the complaint at issue.
        </li>
      </ul>
      <p>
        The DMCA allows us to restore the removed content if the party filing
        the original DMCA Notice does not file a court action against you within
        ten business days of receiving the copy of your Counter Notice.
      </p>
      <p>
        Please be aware that if you knowingly materially misrepresent that
        material or activity on the App was removed or disabled by mistake or
        misidentification, you may be held liable for damages (including costs
        and attorneys&apos; fees) under Section 512(f) of the DMCA.
      </p>
      <p>
        <em>Repeat Infringers</em>
      </p>
      <p>
        It is our policy in appropriate circumstances to disable and/or
        terminate the accounts of users who are repeat infringers.
      </p>
      <h5 className="underline-header">Reliance on Information Portal</h5>
      <p>
        The information presented on or through the App is made available solely
        for general information purposes. We do not warrant the accuracy,
        completeness, or usefulness of this information. Any reliance you place
        on such information is strictly at your own risk. We disclaim all
        liability and responsibility arising from any reliance placed on such
        materials by you or any other visitor to the App, or by anyone who may
        be informed of any of its contents.
      </p>
      <p>
        This App may include content provided by third parties, including
        materials provided by other users, bloggers, and third-party licensors,
        syndicators, aggregators, and/or reporting services. All statements
        and/or opinions expressed in these materials, and all articles and
        responses to questions and other content, other than the content
        provided by the Company, are solely the opinions and the responsibility
        of the person or entity providing those materials. These materials do
        not necessarily reflect the opinion of the Company. We are not
        responsible, or liable to you or any third party, for the content or
        accuracy of any materials provided by any third parties.
      </p>
      <h5 className="underline-header">Changes to the App</h5>
      <p>
        We may update the content on this App from time to time, but its content
        is not necessarily complete or up-to-date. Any of the material on the
        App may be out of date at any given time, and we are under no obligation
        to update such material or continue to provide or enable any particular
        features or functionality. Based on certain device settings, when your
        device is connected to the internet either: (a) the App may
        automatically download and install all available updates; or (b) You may
        receive notice of or be prompted to download and install available
        updates. You shall promptly download and install all updates and
        acknowledge and agree that the App or portions thereof may not properly
        operate should you fail to do so. You further agree that all updates
        will be deemed part of the App and be subject to these Terms of Use.
      </p>
      <h5 className="underline-header">
        Information About You and Your Visits to the App
      </h5>
      <p>
        All information we collect on this App is subject to our Privacy Policy.
        By using the App, you consent to all actions taken by us with respect to
        your information in compliance with the Privacy Policy.
      </p>
      <h5 className="underline-header">Links from the App</h5>
      <p>
        If the App contains links to other sites and resources provided by third
        parties, these links are provided for your convenience only. This
        includes links contained in advertisements, including banner
        advertisements and sponsored links. We have no control over the contents
        of those sites or resources, and accept no responsibility for them or
        for any loss or damage that may arise from your use of them. If you
        decide to access any of the third-party resources linked to this App,
        you do so entirely at your own risk and subject to the terms and
        conditions of use for such resources.
      </p>
      <p>
        The App includes Google Maps features and content. Use of Google Maps
        features and content is subject to the current versions of the: (1)
        Google Maps/Google Earth Additional Terms of Service at{' '}
        <a
          href="https://maps.google.com/help/terms_maps.html"
          target="_blank"
          rel="noopenner noreferrer"
        >
          https://maps.google.com/help/terms_map.html
        </a>
        ; and (2) Google Privacy Policy at{' '}
        <a
          href="https://www.google.com/policies/privacy/"
          target="_blank"
          rel="noopenner noreferrer"
        >
          https://www.google.com/policies/privacy
        </a>
        .
      </p>
      <h5 className="underline-header">Geographic Restrictions</h5>
      <p>
        The owner of the App is based in the State of Massachusetts in the
        United States. We provide this App for use only by persons located in
        the United States. We make no claims that the App or any of its content
        is accessible or appropriate outside of the United States. Access to the
        App may not be legal by certain persons or in certain countries. You
        must not access the App from outside the United States; if you attempt
        to do so, you do so on your own initiative and are responsible for
        compliance with local laws.
      </p>
      <h5 className="underline-header">Disclaimer of Warranties</h5>
      <p>
        You understand that we cannot and do not guarantee or warrant that files
        available for downloading from the internet or the App will be free of
        viruses or other destructive code. You are responsible for implementing
        sufficient procedures and checkpoints to satisfy your particular
        requirements for anti-virus protection and accuracy of data input and
        output, and for maintaining a means external to our App for any
        reconstruction of any lost data. TO THE FULLEST EXTENT PROVIDED BY LAW,
        WE WILL NOT BE LIABLE FOR ANY LOSS OR DAMAGE CAUSED BY A DISTRIBUTED
        DENIAL-OF-SERVICE ATTACK, VIRUSES, OR OTHER TECHNOLOGICALLY HARMFUL
        MATERIAL THAT MAY INFECT YOUR COMPUTER EQUIPMENT, COMPUTER PROGRAMS,
        DATA, OR OTHER PROPRIETARY MATERIAL DUE TO YOUR USE OF THE APP OR ANY
        SERVICES OR ITEMS OBTAINED THROUGH THE APP OR TO YOUR DOWNLOADING OF ANY
        MATERIAL POSTED ON IT, OR ON ANY APP LINKED TO IT.
      </p>
      <p>
        YOUR USE OF THE APP, ITS CONTENT, AND ANY SERVICES OR ITEMS OBTAINED
        THROUGH THE APP IS AT YOUR OWN RISK. THE APP, ITS CONTENT, AND ANY
        SERVICES OR ITEMS OBTAINED THROUGH THE APP ARE PROVIDED ON AN "AS IS"
        AND "AS AVAILABLE" BASIS, WITHOUT ANY WARRANTIES OF ANY KIND, EITHER
        EXPRESS OR IMPLIED. NEITHER THE COMPANY NOR ANY PERSON ASSOCIATED WITH
        THE COMPANY MAKES ANY WARRANTY OR REPRESENTATION WITH RESPECT TO THE
        COMPLETENESS, SECURITY, RELIABILITY, QUALITY, ACCURACY, OR AVAILABILITY
        OF THE APP. WITHOUT LIMITING THE FOREGOING, NEITHER THE COMPANY NOR
        ANYONE ASSOCIATED WITH THE COMPANY REPRESENTS OR WARRANTS THAT THE APP,
        ITS CONTENT, OR ANY SERVICES OR ITEMS OBTAINED THROUGH THE APP WILL BE
        ACCURATE, RELIABLE, ERROR-FREE, OR UNINTERRUPTED, THAT DEFECTS WILL BE
        CORRECTED, THAT OUR APP OR THE SERVER THAT MAKES IT AVAILABLE ARE FREE
        OF VIRUSES OR OTHER HARMFUL COMPONENTS, OR THAT THE APP OR ANY SERVICES
        OR ITEMS OBTAINED THROUGH THE APP WILL OTHERWISE MEET YOUR NEEDS OR
        EXPECTATIONS.
      </p>
      <p>
        TO THE FULLEST EXTENT PROVIDED BY LAW, THE COMPANY HEREBY DISCLAIMS ALL
        WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED, STATUTORY, OR
        OTHERWISE, INCLUDING BUT NOT LIMITED TO ANY WARRANTIES OF
        MERCHANTABILITY, NON-INFRINGEMENT, AND FITNESS FOR PARTICULAR PURPOSE.
      </p>
      <p>
        THE FOREGOING DOES NOT AFFECT ANY WARRANTIES THAT CANNOT BE EXCLUDED OR
        LIMITED UNDER APPLICABLE LAW.
      </p>
      <h5 className="underline-header">Limitation on Liability</h5>
      <p>
        TO THE FULLEST EXTENT PROVIDED BY LAW, IN NO EVENT WILL THE COMPANY, ITS
        AFFILIATES, OR THEIR LICENSORS, SERVICE PROVIDERS, EMPLOYEES, AGENTS,
        OFFICERS, OR DIRECTORS BE LIABLE FOR DAMAGES OF ANY KIND, UNDER ANY
        LEGAL THEORY, ARISING OUT OF OR IN CONNECTION WITH YOUR USE, OR
        INABILITY TO USE, THE APP, ANY APPS LINKED TO IT, ANY CONTENT ON THE APP
        OR SUCH OTHER APPS, INCLUDING ANY DIRECT, INDIRECT, SPECIAL, INCIDENTAL,
        CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING BUT NOT LIMITED TO,
        PERSONAL INJURY, PAIN AND SUFFERING, EMOTIONAL DISTRESS, LOSS OF
        REVENUE, LOSS OF PROFITS, LOSS OF BUSINESS OR ANTICIPATED SAVINGS, LOSS
        OF USE, LOSS OF GOODWILL, LOSS OF DATA, AND WHETHER CAUSED BY TORT
        (INCLUDING NEGLIGENCE), BREACH OF CONTRACT, OR OTHERWISE, EVEN IF
        FORESEEABLE.
      </p>
      <p>
        BY ACCESSING THE APP, THEIR CONTENT, AND ANY SERVICES OR ITEMS OBTAINED
        THROUGH THE APP, YOU UNDERSTAND THAT YOU MAY BE WAIVING RIGHTS WITH
        RESPECT TO CLAIMS THAT ARE AT THIS TIME UNKNOWN OR UNSUSPECTED, AND IN
        ACCORDANCE WITH SUCH WAIVER, YOU ACKNOWLEDGE THAT YOU HAVE READ AND
        UNDERSTAND, AND HEREBY EXPRESSLY WAIVE, THE BENEFITS OF SECTION 1542 OF
        THE CIVIL CODE OF CALIFORNIA, AND ANY SIMILAR LAW OF ANY STATE OR
        TERRITORY, WHICH PROVIDES AS FOLLOWS: “A GENERAL RELEASE DOES NOT EXTEND
        TO CLAIMS THAT THE CREDITOR OR RELEASING PARTY DOES NOT KNOW OR SUSPECT
        TO EXIST IN HIS OR HER FAVOR AT THE TIME OF EXECUTING THE RELEASE AND
        THAT, IF KNOWN BY HIM OR HER, WOULD HAVE MATERIALLY AFFECTED HIS OR HER
        SETTLEMENT WITH THE DEBTOR OR RELEASED PARTY.”
      </p>
      <p>
        The limitation of liability set out above does not apply to liability
        resulting from our gross negligence or willful misconduct.
      </p>
      <p>
        THE FOREGOING DOES NOT AFFECT ANY LIABILITY THAT CANNOT BE EXCLUDED OR
        LIMITED UNDER APPLICABLE LAW.
      </p>
      <h5 className="underline-header">Indemnification</h5>
      <p>
        You agree to defend, indemnify, and hold harmless the Company, its
        affiliates, licensors, and service providers, and its and their
        respective officers, directors, employees, contractors, agents,
        licensors, suppliers, successors, and assigns from and against any
        claims, liabilities, damages, judgments, awards, losses, costs,
        expenses, or fees (including reasonable attorneys&apos; fees) arising
        out of or relating to your violation of these Terms of Use or your use
        of the App, including, but not limited to, any use of the App&apos;s
        content, services, and products other than as expressly authorized in
        these Terms of Use, or your use of any information obtained from the
        App.
      </p>
      <h5 className="underline-header">Governing Law and Jurisdiction</h5>
      <p>
        All matters relating to a Team Member&apos;s use of the App and these
        Terms of Use, and any dispute or claim arising therefrom or related
        thereto (in each case, including non-contractual disputes or claims),
        shall be governed by and construed in accordance Clayton&apos;s
        Employment Dispute Resolution Agreement.
      </p>
      <p>
        All matters relating to an Independent Retailer or an Independent
        Retailer&apos;s subcontractor&apos;s use of the App and these Terms of
        Use, and any dispute or claim arising therefrom or related thereto (in
        each case, including non-contractual disputes or claims), shall be
        governed by and construed in accordance with the Retailer Sales and
        Services Agreement.
      </p>
      <h5 className="underline-header">Waiver and Severability</h5>
      <p>
        No waiver by the Company of any term or condition set out in these Terms
        of Use shall be deemed a further or continuing waiver of such term or
        condition or a waiver of any other term or condition, and any failure of
        the Company to assert a right or provision under these Terms of Use
        shall not constitute a waiver of such right or provision.
      </p>
      <p>
        If any provision of these Terms of Use is held by a court or other
        tribunal of competent jurisdiction to be invalid, illegal, or
        unenforceable for any reason, such provision shall be eliminated or
        limited to the minimum extent such that the remaining provisions of the
        Terms of Use will continue in full force and effect.
      </p>
      <h5 className="underline-header">Export Regulation</h5>
      <p className="underline-text">
        The App may be subject to US export control laws, including the Export
        Control Reform Act and its associated regulations. You shall not,
        directly or indirectly, export, re-export, or release the App to, or
        make the App accessible from, any jurisdiction or country to which
        export, re-export, or release is prohibited by law, rule, or regulation.
        You shall comply with all applicable federal laws, regulations, and
        rules, and complete all required undertakings (including obtaining any
        necessary export license or other governmental approval), prior to
        exporting, re-exporting, releasing, or otherwise making the App
        available outside the US.
      </p>
      <h5 className="underline-header">US Government Rights</h5>
      <p className="underline-text">
        The App is commercial computer software, as such term is defined in 48
        C.F.R. §2.101. Accordingly, if you are an agency of the US Government or
        any contractor therefor, you receive only those rights with respect to
        the App as are granted to all other end users under license, in
        accordance with (a) 48 C.F.R. §227.7201 through 48 C.F.R. §227.7204,
        with respect to the Department of Defense and their contractors, or (b)
        48 C.F.R. §12.212, with respect to all other US Government licensees and
        their contractors.
      </p>
      <h5 className="underline-header">Entire Agreement</h5>
      <p>
        The Terms of Use and our Privacy Policy constitute the sole and entire
        agreement between you and Clayton regarding the App and supersede all
        prior and contemporaneous understandings, agreements, representations,
        and warranties, both written and oral, regarding the App.
      </p>
      <h5 className="underline-header">Your Comments and Concerns</h5>
      <p>
        This App is operated by Dispatch at 27 School Street, 4th Floor, Boston,
        MA 02108.
      </p>
      <p>
        Requests for technical support should be directed to:{' '}
        <a href="mailto:HX@claytonhomes.com">HX@claytonhomes.com</a>.
      </p>
      <p>
        All other feedback, comments, and other communications relating to the
        App should be directed to:{' '}
        <a href="mailto:HX@claytonhomes.com">HX@claytonhomes.com</a> or by
        writing to Homeowner Experience, 5000 Clayton Road, Maryville, TN 37804.
      </p>
      <h5>Additional Terms Related to Apple</h5>
      <ol type="a">
        <li>
          <strong>Acknowledgement</strong>: You acknowledge that these Terms of
          Use are concluded between you and Clayton only, and not with Apple,
          and Clayton, not Apple, is solely responsible for the App and the
          content thereof.
        </li>
        <li>
          <strong>Scope of License</strong>: The license granted to you for the
          App is limited to a non-transferable license to use the App on any
          Apple-branded Products that you own or control and as permitted by the
          Usage Rules set forth in the Apple Media Services Terms and
          Conditions, except that such App may be accessed and used by other
          accounts associated with the purchaser via Family Sharing or volume
          purchasing.
        </li>
        <li>
          <strong>Maintenance and Support</strong>: Clayton is solely
          responsible for providing any maintenance and support services with
          respect to the App, as specified in the Terms of Use, or as required
          under applicable law. You acknowledge that Apple has no obligation
          whatsoever to furnish any maintenance and support services with
          respect to the App.
        </li>
        <li>
          <strong>Warranty</strong>: Clayton is solely responsible for any
          product warranties, whether express or implied by law, to the extent
          not effectively disclaimed. In the event of any failure of the App to
          conform to any applicable warranty, you may notify Apple, and Apple
          will refund the purchase price for the App to you. To the maximum
          extent permitted by applicable law, Apple will have no other warranty
          obligation whatsoever with respect to the App, and any other claims,
          losses, liabilities, damages, costs or expenses attributable to any
          failure to conform to any warranty will be Clayton&apos;s sole
          responsibility.
        </li>
        <li>
          <strong>Product Claims</strong>: You acknowledge that Clayton, not
          Apple, is responsible for addressing any claims from you or any third
          party relating to the App or your possession and/or use of the App,
          including, but not limited to: (i) product liability claims; (ii) any
          claim that the App fails to conform to any applicable legal or
          regulatory requirement; and (iii) claims arising under consumer
          protection, privacy, or similar legislation, including in connection
          with the App&apos;s use of the HealthKit and HomeKit frameworks.
        </li>
        <li>
          <strong>Intellectual Property Rights</strong>: You acknowledge that,
          in the event of any third-party claim that the App or your possession
          and use of the App infringe that third party&apos;s intellectual
          property rights, Clayton, not Apple, will be solely responsible for
          the investigation, defense, settlement and discharge of any such
          intellectual property infringement claim.
        </li>
        <li>
          <strong>Legal Compliance</strong>: You represent and warrant that (i)
          you are not located in a country that is subject to a U.S. Government
          embargo, or that has been designated by the U.S. Government as a
          “terrorist supporting” country; and (ii) you are not listed on any
          U.S. Government list of prohibited or restricted parties.
        </li>
        <li>
          <strong>Third-Party Terms of Agreement</strong>: You must comply with
          applicable third-party terms of agreement when using the App.
        </li>
        <li>
          <strong>Third-Party Beneficiary</strong>: You acknowledge and agree
          that Apple, and Apple&apos;s subsidiaries, are third-party
          beneficiaries of the Terms of Use, and that, upon your acceptance of
          the terms and conditions of the Terms of Use, Apple will have the
          right (and will be deemed to have accepted the right) to enforce the
          Terms of Use against you as a third-party beneficiary thereof.
        </li>
      </ol>
      <h5>Additional Terms Related to Google</h5>
      <p>
        By downloading the App from Google Play (or its successors) operated by
        Google, Inc. or one of its affiliates ("<strong>Google</strong>"), you
        specifically acknowledge and agree that:
      </p>
      <ol type="a">
        <li>
          To the extent of any conflict between (a) the Google Play Terms of
          Services and the Google Play Business and Program Policies or such
          other terms which Google designates as default end user license terms
          for Google Play (all of which together are referred to as the ("
          <strong>Google Play Terms</strong>"), and (b) the other terms and
          conditions in these Terms of Use, the Google Play Terms shall apply
          with respect to your use of the App that you download from Google
          Play.)
        </li>
        <li>
          Google does not have any responsibility or liability related to
          compliance or non-compliance by Clayton or you (or any other user)
          under these Terms of Use or the Google Play Terms.
        </li>
        <li>
          You must contact Clayton concerning any defects or performance issues
          in the App. Clayton is solely responsible for providing, and Google
          has no obligation to provide, maintenance and support for the App.
          Support requests, as well as questions, complaints, or claims
          regarding the App, may be directed to: Online Privacy Department, 5000
          Clayton Rd., Maryville, TN 37804.
        </li>
        <li>
          These Terms of Use are solely between you and Clayton only, and not
          with Google. Google is only a provider of the Google Play Store where
          you acquired the App ("<strong>Google-Sourced Software</strong>").
          Clayton, and not Google, is solely responsible for its Google-Sourced
          Software. Your use of Google-Sourced Software must comply with
          Google&apos;s then-current Google Play Store Terms of Service.
        </li>
        <li>
          Google has no obligation or liability to you with respect to
          Google-Sourced Software or the Terms of Use.
        </li>
        <li>
          Google is a third-party beneficiary to the Terms of Use as it relates
          to Clayton&apos;s Google-Sourced Software.
        </li>
      </ol>
    </section>
  );
};
